const fonts = {
  primary: `'Josefin Sans', sans-serif`,
  secondary: `'Inter', sans-serif`,
};

export default fonts;
